import { percentageSignFilter, simplePercentageFilter } from "app/filters/ngFilters";

export const CONVERSION_RATE_TRANSLATION_KEYS = {
    title: "wa.ao.conversionrate",
    tooltip: "wa.ao.conversionrate.tooltip",
    lockedTitle: "wa.ao.conversionrate.locked.title",
    lockedCta: "wa.ao.conversionrate.locked.cta",
    emptyCountryNotSupportedTitle: "wa.ao.conversionrate.country.unavailable.title",
    emptyCountryNotSupportedSubtitle: "wa.ao.conversionrate.country.unavailable.subtitle",
    emptyCountryNotSupportedCta: "wa.ao.conversionrate.country.unavailable.cta",
    emptyNoDataTitle: "wa.ao.conversionrate.data.unavailable.title",
    emptyNoDataSubtitle: "wa.ao.conversionrate.data.unavailable.subtitle",
    changeText: "wa.ao.totalvisits.change.lastmonth",
    changeNA: "wa.ao.totalvisits.change.na",
} as const;

export const conversionRateFormatters = {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    conversionRate: (value: number) => percentageSignFilter()(value, 1),
    change: (value: number) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const result = simplePercentageFilter()(value, 1);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result === "N/A" ? result : `${result}pp`;
    },
};
